import config from "../config"
const baseUrl = config.base_url + "container_space_time_phenology_risk/"
export default {
    get: {
        url: baseUrl + "get",
        type: "get",
    },
    save: {
        url: baseUrl + "save",
        type: "post",
    },
    delete: {
        url: baseUrl + "delete",
        type: "get",
    },
    listBySpaceTimePhenologyId: {
        url: baseUrl + "listBySpaceTimePhenologyId",
        type: "get",
    },
    listReproductiveMap: {
        url: baseUrl + "listReproductiveMapBySpaceTimePhenologyId",
        type: "get",
    },
    toggleFollow: {
        url: baseUrl + "toggleFollow",
        type: "get",
    },
}
